import TYPES from '../../types';

// Domain
import { EmailEntity } from '../../domain/entities/email-entity';
import Query from '@/modules/shared/domain/use-cases/query';
import SearchEmailRepository from '../../domain/repository/search-email-repository';
import StateManager from '../../domain/state/state-manager';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';

@Injectable()
export default class SearchMyInvestmentEmailsQuery extends Query<Promise<Array<EmailEntity>>> {
  @Inject(TYPES.MY_INVESTMENT_EMAIL_STATE_MANAGER)
  private readonly state_manager!: StateManager;

  @Inject(TYPES.SEARCH_MY_INVESTMENT_EMAIL_REPOSITORY)
  private readonly repository!: SearchEmailRepository;

  internalExecute(): Promise<Array<EmailEntity>> {
    return new Promise((resolve, reject) => {
      if (!this.state_manager.state.loaded) {
        this.repository.execute()
          .then((items) => {
            this.state_manager.patch({ items, loaded: true });
            resolve(items);
          })
          .catch(reject);
      } else {
        resolve(this.state_manager.state.items);
      }
    });
  }
}
